export const isUserLogin = () => {
	return !!localStorage.getItem("user");
};
